export default __webpack_public_path__ + "static/media/main_section13.54dc0e47.jpg";